var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefDoctorsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2836_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 14.7996V12.7996C13.3346 10.9143 13.3346 9.97097 12.7486 9.38564C12.1633 8.79964 11.22 8.79964 9.33464 8.79964L8.0013 10.133L6.66797 8.79964C4.78264 8.79964 3.8393 8.79964 3.25397 9.38564C2.66797 9.97097 2.66797 10.9143 2.66797 12.7996V14.7996M10.668 10.7996V12.7996M11.668 11.7996H9.66797M10.3346 4.46631V3.79964C10.3346 3.49322 10.2743 3.18981 10.157 2.90671C10.0398 2.62362 9.86789 2.3664 9.65122 2.14973C9.43455 1.93306 9.17732 1.76118 8.89423 1.64392C8.61114 1.52666 8.30772 1.46631 8.0013 1.46631C7.69488 1.46631 7.39147 1.52666 7.10837 1.64392C6.82528 1.76118 6.56806 1.93306 6.35139 2.14973C6.13472 2.3664 5.96284 2.62362 5.84558 2.90671C5.72832 3.18981 5.66797 3.49322 5.66797 3.79964V4.46631C5.66797 4.77273 5.72832 5.07614 5.84558 5.35924C5.96284 5.64233 6.13472 5.89955 6.35139 6.11622C6.56806 6.33289 6.82528 6.50477 7.10837 6.62203C7.39147 6.73929 7.69488 6.79964 8.0013 6.79964C8.30772 6.79964 8.61114 6.73929 8.89423 6.62203C9.17732 6.50477 9.43455 6.33289 9.65122 6.11622C9.86789 5.89955 10.0398 5.64233 10.157 5.35924C10.2743 5.07614 10.3346 4.77273 10.3346 4.46631Z",
    stroke: "#9BA4AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2836_1446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.133057)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefDoctorsIcon);
export default __webpack_public_path__ + "static/media/ref_doctors-icon.45bdd929b9434d569aa0b4c2147c074d.svg";
export { ForwardRef as ReactComponent };